import { fetchApi } from '@/config/axiosSetting';
import {
  GetSurveySummaryQueryParamsType,
  GetSurveySummaryQueryResponseType,
} from './getSurveySummaryQuery.type';

export const getSurveySummaryFunction = (
  params: GetSurveySummaryQueryParamsType,
): Promise<GetSurveySummaryQueryResponseType> => {
  return fetchApi.get('/survey/survey_summary/', {
    params,
  });
};
